import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';

import {
  PageHeader,
  // RadioButtons,
  Gap,
  FormLabel,
  // Checkbox,
  Button,
  ExternalLink,
} from '~ui-kit';
import { primaryColor } from '~theme';

import TextareaField from '~fields/TextareaField';
import SelectField from '~fields/SelectField';
import CheckboxField from '~fields/CheckboxField';
import PhoneField from '~fields/PhoneField';
import RadioButtonField from '~fields/RadioButtonField';

import { Buttons } from '../../forms/styled';

import { submitFeedback } from '../modals/ducks';
import { isPhoneNumberValid, removeEmptyKeys } from '../../forms/validations';

const feedbackOptions = [
  { label: 'Kysy tai anna palautetta', value: 'MESSAGE_FEEDBACK' },
  { label: 'Ilmoita ongelmasta', value: 'MESSAGE_TROUBLE_REPORT' },
  { label: 'Kehitysidea', value: 'MESSAGE_IDEA' },
];

const validate = values => {
  const errors = {};

  if (values.contactSender) {
    errors.contactPhone = isPhoneNumberValid(values.contactPhone);
  }

  if (!values.message) {
    errors.message = 'Vaadittu';
  }

  return removeEmptyKeys(errors);
};

const FeedbackView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const categories = useSelector(state => state.reducer.inventoryCategories);
  const labels = useSelector(state => state.user.data.labels);
  const { coordinatorsEmail, coordinatorsPhone } = labels;

  const categoryOptions = categories.map(unit => ({
    value: unit.id.toString(),
    label: unit.name,
    genericFeedbackUrl: unit.genericFeedbackUrl,
  }));

  return (
    <Formik
      initialValues={{
        type: 'MESSAGE_FEEDBACK',
        category: null,
        message: '',
        contactSender: false,
        contactPhone: '',
      }}
      validate={validate}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        dispatch(
          submitFeedback({
            ...values,
            categoryId: values.category?.value,
          })
        );
        navigate('/tilauslista');
      }}
    >
      {formikProps => {
        const { contactSender, category } = formikProps.values;
        return (
          <Wrapper>
            <PageHeader>Ota yhteyttä</PageHeader>
            <Gap height="10px" />
            <Grid>
              <GridLabel>Chat-palvelu</GridLabel>
              <GridDetail>Saara-botti palvelee 24/7</GridDetail>
              <GridLabel>Sähköpostitse</GridLabel>{' '}
              <GridDetail>
                <a href={`mailto:${coordinatorsEmail}`}>{coordinatorsEmail}</a>
              </GridDetail>
              <GridLabel>Puhelimitse</GridLabel>
              <GridDetail>
                Arkisin klo 8-15 numerosta{' '}
                <a href={`tel:${coordinatorsPhone}`}>{coordinatorsPhone}</a>
              </GridDetail>
            </Grid>
            <br />
            <br />
            <hr />
            <br />
            <br />
            <HeaderLabel>Mitä haluat meille kertoa?</HeaderLabel>
            <RadioButtonField options={feedbackOptions} name="type" />
            <Gap height="8px" />
            <FormLabel>Palvelu, jota asiasi koskee</FormLabel>
            <SelectField
              name="category"
              placeholder="Valitse"
              options={categoryOptions}
              isClearable
            />
            <Gap height="24px" />
            {!!category?.genericFeedbackUrl && (
              <>
                <GenericFeedback>
                  Anna palautetta suoraan palveluntuottajalle:{' '}
                  <ExternalLink href={category.genericFeedbackUrl}>
                    Linkki
                  </ExternalLink>
                </GenericFeedback>
                <Gap height="24px" />
              </>
            )}
            <FormLabel required>Kommenttisi</FormLabel>
            <TextareaField
              name="message"
              className="form-control"
              maxLength={2000}
              rows={5}
              placeholder="Kirjoita kuvaus asiasta/tapahtumasta"
            />
            <Gap height="24px" />
            <CheckboxField
              label="Haluan, että minuun ollaan yhteydessä"
              name="contactSender"
            />
            {contactSender && (
              <>
                <Gap height="24px" />
                <PhoneField
                  label="Puhelinnumero"
                  required
                  placeholder="esim. 040..."
                  name="contactPhone"
                />
              </>
            )}
            <Gap height="38px" />
            <Buttons>
              <Button cancel onClick={() => navigate('/tilauslista')}>
                Peruuta
              </Button>
              <Button
                secondary
                type="submit"
                onClick={formikProps.handleSubmit}
              >
                Lähetä
              </Button>
            </Buttons>
          </Wrapper>
        );
      }}
    </Formik>
  );
};

const Wrapper = styled.div`
  padding: 35px;
  max-width: 540px;

  @media (max-width: 768px) {
    padding: 0px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: auto auto;

  gap: 12px;
`;

const GridLabel = styled.div`
  color: ${primaryColor};
  font-size: 16px;
  line-height: 1.5;
`;

const HeaderLabel = styled(FormLabel)`
  & {
    margin-bottom: 24px;
  }
`;

const GridDetail = styled.div`
  font-size: 16px;
  word-break: break-word;
  hyphens: none;
  line-height: 1.5;
`;

const GenericFeedback = styled.div`
  color: ${primaryColor};
  font-size: 16px;
  line-height: 1.5;
`;

export default FeedbackView;
